/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-23 14:21:08
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-11-12 16:00:15
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorShoppingCartPage/SalesChannelEditorShoppingCartPage.tsx
 */
import React from 'react';

import css from './css.less';

import BasicPageHOC from 'src/constrains/SalesChannelPreviewPageComponents/SalesChannelContentBasicPageHOC';

import RouteBlock from './RouteBlock';

//import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { dispatch } from 'src/store';

import PageWrapper from '../../../constrains/SalesChannelPreviewPageComponents/PageWrapper/PageWrapper';
import RightConfigWrapper from '../../../constrains/SalesChannelPreviewPageComponents/RightConfigWrapper';
//import Preview from './Preview';

//import { IParams } from 'src/pages/SalesChannelContentEditor/common';

import { WebSiteSubType } from '@/src/types/common/SalesChannel';
import { useI18n } from 'src/hooks/useRouterChange';
import { convertDataFromReduxToServer } from 'src/pages/SalesChannelContentEditor/SalesChannelEditorShoppingCartPage/tools';
import { getContentButtonThemes } from 'src/request/salesChannel/content';
import { i18nGet } from 'src/tools/tools';
import ButtonText from './ButtonText';
import CloneBtn from './CloneButton';
import EmptyStateSetting from './EmptyStateSetting';
import FeaturedProducts from './FeaturedProducts';
import NoticeBoard from './NoticeBoard';
import {
  fetchContentShoppingCart,
  getHasModified,
  //isNoticeBoardOpening,
  getLoaded,
  getSalesChannel,
  getSalesChannelName,
  getState,
  resetData,
  //submitContentHomepage,  submitContentShoppingCart,
  submitContentShoppingCart,
  validation,
} from './slice';

const SalesChannelEditorShoppingCartPage = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    onDiscard,
    onGoBack,
    submitData,
    hasModified,
    salesChannel,
    salesChannelName,
    isOnPrimaryLanguage,
    //currentSize,
    currentStyle,
    isMini,
  } = props;

  const hideRightPart = !isMini;

  const _params: {
    saleChannelUuid: string;

    contentUuid: string;
  } = useParams();
  const { contentUuid } = _params;

  const [themeList, setThemesList] = React.useState([]);

  React.useEffect(() => {
    getContentButtonThemes(contentUuid).then((res) => {
      setThemesList(res);
      //console.log(res);
    });
  }, []);

  const _d = useDispatch();
  // const _history = useHistory();
  //const _params: IParams = useParams();
  //const { contentUuid } = _params;
  React.useEffect(() => {
    // _d(
    //   fetchContentShoppingCart({
    //     uuid: contentUuid,
    //   }),
    // );

    return () => {
      _d(resetData());
    };
  }, []);

  const _leftChild = (
    <div className={css.left}>
      {/* <Preview isNoticeBoardOpening={isNoticeBoardOpening} /> */}
    </div>
  );

  const _rightChild = (
    <RightConfigWrapper
      title={getI18n('general.sider.shoppingCartPage')}
      wrapperClassName={hideRightPart ? 'wrapperWithoutLeft' : ''}
      elements={[
        {
          body: (
            <React.Fragment>
              {!isOnPrimaryLanguage && <CloneBtn />}
              <EmptyStateSetting
                isPrimary={isOnPrimaryLanguage}
                collapseOpenDefault={hideRightPart}
              />
              <ButtonText
                themeList={themeList}
                isPrimary={isOnPrimaryLanguage}
                collapseOpenDefault={hideRightPart}
                isResponsive={currentStyle === WebSiteSubType.ResponsivePage}
              />
            </React.Fragment>
          ),
          key: 'TopConfig',
        },
        {
          body: (
            <React.Fragment>
              <FeaturedProducts
                isPrimary={isOnPrimaryLanguage}
                collapseOpenDefault={hideRightPart}
              />
              <NoticeBoard
                isPrimary={isOnPrimaryLanguage}
                collapseOpenDefault={hideRightPart}
              />
            </React.Fragment>
          ),
          key: 'FeaturedProducts',
        },
      ]}
    />
  );
  return (
    <React.Fragment>
      <RouteBlock hasModified={hasModified} />
      <PageWrapper
        headerConfig={{
          hasModified,
          submit: submitData,
          salesChannelContentData: salesChannel || {},
          salesChannelName: salesChannelName,
          onDiscard,
          onGoBack,
          hasStyleSelect: false,
        }}
        hideRightPart={hideRightPart}
        withoutCollapse={hideRightPart}
        leftChild={hideRightPart ? _rightChild : _leftChild}
        rightChild={hideRightPart ? _leftChild : _rightChild}
      />
    </React.Fragment>
  );
};
export default BasicPageHOC(SalesChannelEditorShoppingCartPage, {
  getState,
  convertDataFromReduxToServer,
  submit: submitContentShoppingCart,
  siteStyleInParams: true,
  previewSizeInParams: true,
  getHasModified,
  getSalesChannel,
  getSalesChannelName,
  validation,
  getLoaded,
  queryData: (params, qParams) => {
    const { contentUuid } = params;
    dispatch(
      fetchContentShoppingCart({
        uuid: contentUuid,
        params: qParams,
      }),
    );
  },
});
